module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre1"
  }, [_c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("The Conflagration of Community: Fiction before and after Auschwitz")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    attrs: {
      "id": "para1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("J. Hillis Miller")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "para",
    attrs: {
      "id": "para2"
    }
  }, [_vm._v("The University of Chicago Press :: Chicago and London")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c75c9dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/titlepage.vue
// module id = 57
// module chunks = 0